import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PeerStatus from './PeerStatus';
import IconButton from '@material-ui/core/IconButton';
import PostAddIcon from '@material-ui/icons/PostAdd';
import Linkify from 'react-linkify';
import Typography from '@material-ui/core/Typography';
import VideocamIcon from '@material-ui/icons/Videocam';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'calc(100% - 140px)',
    overflowY: 'auto',
    marginTop: 0,
    paddingLeft: 20,
    paddingRight: 20,
    '& li': {
      listStyleType: 'none',
      float: 'left',
      clear: 'both',
      marginTop: 10,
      '& .msg': {
        marginTop: 2,
        padding: '8px 24px',
        marginLeft: 0,
        borderRadius: 10,
        borderTopLeftRadius: 0,
        backgroundColor: '#fefefe',
        borderColor: '#222',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        letterSpacing: '0.0375rem',
        fontWeight: 400,
        fontSize: 16
      }
    },
    '& li.local': {
      float: 'right',
      clear: 'both',
    },
    '& li.local .sup': {
      textAlign: 'right'
    },
    '& li.local .msg': {
      borderRadius: 10,
      borderBottomRightRadius: 0,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary[700],
      borderColor: '#222',
      position: 'relative',
      '& button': {
        position: 'absolute',
        left: -36,
        top: -6,
        zIndex: 1001,
        display: 'none',
      },
      '&:hover': {
        backgroundColor: theme.palette.primary[600],
      },
      '&:hover button': {
        display: 'block',
      },
      '& .MuiSvgIcon-root': {
        fill: theme.palette.common.white,
      },
      '& a': {
        color: theme.palette.common.white,
      }
    }
  }
}));

const renderStatus = (props) => {
  return <PeerStatus {...props} />
}

export default function messages(props) {

  const renderMessage = (msg, key) => {
    let prepend = '';
    if(props.onSaveMessage && (msg.source == 'local')) {
      prepend = <IconButton onClick={()=>props.onSaveMessage(msg.message)}><PostAddIcon /></IconButton>;
    }
    if(msg.message.message && msg.message.message.startsWith('/video_chat')) {
      return (<li key={key} className={ msg.source }>
        <Typography variant="caption">{msg.message.from ? msg.message.from : ''}</Typography>
        <Typography className='msg' component='div'>
          <VideocamIcon /> <div style={{display: 'inline-block', verticalAlign: 'top'}}>video chat</div>
        </Typography>
      </li>);
    }

    if(msg.message.message && msg.message.message.startsWith('/end_video_chat')) {
      return (<li key={key} className={ msg.source }>
        <Typography variant="caption">{msg.message.from ? msg.message.from : ''} ended video chat.</Typography>
      </li>);
    }

    return (<li key={key} className={ msg.source }>

      <Typography variant="caption">{msg.message.from ? msg.message.from : ''}</Typography>
      <Typography className='msg' component='div'>
        {prepend}
        <Linkify
        componentDecorator={(decoratedHref, decoratedText, key) => (
        <a target="blank" href={decoratedHref} key={key}>
            {decoratedText}
        </a>
        )} >{msg.message.message ? msg.message.message : msg.message}</Linkify>
      </Typography>
    </li>);
  };

  let messages = props.messages.map( (msg, key) => renderMessage(msg,key) );
  // to scroll to bottom on update
  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    if( props.messages.length > 0 ) {
      setTimeout( () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        console.log("scroll to bottom");
      }, 250 );
    }
  }
  useEffect(scrollToBottom, [props.messages.length]);
  //
  const classes = useStyles();
  return (
    <ul className={classes.root}>
      {props.children}
      {messages}
      {renderStatus(props)}
      <div style={{clear:'both', height: 10}} ref={messagesEndRef} />
    </ul>
  );
}
